"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECONDARY_NAV_TEXT_COLOR = exports.SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = exports.SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = exports.SECONDARY_NAV_ITEM_OUTLINE_WIDTH = exports.SECONDARY_NAV_ITEM_OUTLINE_COLOR = exports.SECONDARY_NAV_ITEM_BORDER_COLOR = exports.SECONDARY_NAV_HEIGHT = exports.SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = exports.SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = exports.SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = exports.SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = exports.SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = exports.SECONDARY_NAV_BORDER_COLOR = exports.SECONDARY_NAV_BACKGROUND_COLOR = void 0;
var SECONDARY_NAV_HEIGHT = 64;
exports.SECONDARY_NAV_HEIGHT = SECONDARY_NAV_HEIGHT;
var SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = 16;
exports.SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = SECONDARY_NAV_ITEM_PADDING_HORIZONTAL;
var SECONDARY_NAV_ITEM_OUTLINE_WIDTH = 2;
exports.SECONDARY_NAV_ITEM_OUTLINE_WIDTH = SECONDARY_NAV_ITEM_OUTLINE_WIDTH;
var SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = 4;
exports.SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT;
var SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = 8;
exports.SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING;
var SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = 16;
exports.SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING;
var SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = 220;
exports.SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH;
var SECONDARY_NAV_TEXT_COLOR = 'neutral90';
exports.SECONDARY_NAV_TEXT_COLOR = SECONDARY_NAV_TEXT_COLOR;
var SECONDARY_NAV_BACKGROUND_COLOR = 'neutral05';
exports.SECONDARY_NAV_BACKGROUND_COLOR = SECONDARY_NAV_BACKGROUND_COLOR;
var SECONDARY_NAV_BORDER_COLOR = 'neutral20';
exports.SECONDARY_NAV_BORDER_COLOR = SECONDARY_NAV_BORDER_COLOR;
var SECONDARY_NAV_ITEM_OUTLINE_COLOR = 'neutral100';
exports.SECONDARY_NAV_ITEM_OUTLINE_COLOR = SECONDARY_NAV_ITEM_OUTLINE_COLOR;
var SECONDARY_NAV_ITEM_BORDER_COLOR = 'neutral80';
exports.SECONDARY_NAV_ITEM_BORDER_COLOR = SECONDARY_NAV_ITEM_BORDER_COLOR;
var SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = 'primary70';
exports.SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR;
var SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = 'neutral05';
exports.SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR;